document.addEventListener( 'DOMContentLoaded', function () {
	const { showFiltersTxt, hideFiltersTxt } = window.l18n_js_theme;
	const toggleBtns = document.querySelectorAll( '[rel="toggle-categories"]' );
	const toggleBtnSidebar = document.querySelector( '[rel="toggle-sidebar"]' );
	const productCategoriesDiv = document.querySelector(
		'.wp-block-licht-concept-blocks-product-categories'
	);
	const sortBy = document.querySelector( '.shop-select-orderby' );
	if ( sortBy ) {
		const sortByClone = sortBy.cloneNode( true );
		sortByClone.classList.add( 'shop-select-orderby-cloned' );
		// sortBy.remove();
		if ( productCategoriesDiv && sortByClone ) {
			productCategoriesDiv.after( sortByClone );
		}
	}

	toggleBtns.forEach( ( toggleBtn ) => {
		toggleBtn.addEventListener( 'click', function () {
			const isSidebarToggleBtn = this.classList.contains(
				'toggle-sidebar-categories'
			);
			const controlled = document.getElementById(
				this.getAttribute( 'aria-controls' )
			);
			const expanded =
				this.getAttribute( 'aria-expanded' ) === 'true' || false;
			const shopStorage = localStorage.getItem( 'shopSettings' );
			const shopSettings = JSON.parse( shopStorage ) || {};
			this.setAttribute( 'aria-expanded', ! expanded );

			if ( ! isSidebarToggleBtn ) {
				if ( ! expanded ) {
					this.querySelector( 'span' ).innerText = hideFiltersTxt;
				} else {
					this.querySelector( 'span' ).innerText = showFiltersTxt;
				}
			}

			controlled.classList.toggle( 'product-filters-active' );
		} );
	} );

	document.querySelectorAll( '.category-box h3' ).forEach( ( title ) => {
		title.addEventListener( 'click', function () {
			this.parentElement.classList.toggle( 'active' );
		} );
	} );
	const closeSidebar = () => {
		const root = document.querySelector(
			'.wp-block-licht-concept-blocks-product-categories'
		);
		if ( ! root ) {
			return;
		}

		// Close open category filter dropdowns when clicking outside the block.
		document.addEventListener( 'click', function ( event ) {
			const clickedInside = root.contains( event.target );
			const clickedToggle = event.target.closest( '[rel="toggle-categories"]' );

			if ( ! clickedInside && ! clickedToggle ) {
				// querySelectorAll misses the root element itself, so search
				// the whole document for any open filter panel.
				document
					.querySelectorAll( '.product-filters-active' )
					.forEach( ( el ) =>
						el.classList.remove( 'product-filters-active' )
					);
			}
		} );
	};
	closeSidebar();
} );
